import { I18n } from 'Locales/I18nService';
import { useDialogs } from 'Web/Services/useDialogs';

type MenuDeleteDialogParams = { description: string; confirmDelete?: VoidFunction };
export const useMenuDeleteDialog = ({ description, confirmDelete }: MenuDeleteDialogParams) => {
    const dialogs = useDialogs();
    const requestDelete = () => {
        dialogs.showYesNoChoice({
            noHighlight: true,
            enableCloseOutside: false,
            title: I18n.get('MapContextMenu_Delete_Title'),
            subtitle: description,
            onClickNo: ({ closeDialog }) => closeDialog(),
            onClickYes: ({ closeDialog }) => {
                confirmDelete?.();
                closeDialog();
            },
        });
    };
    return { requestDelete };
};
